import { BadgeAlt } from ".."
import { PRODUCT_LINE_LABELS, ProductLine } from "../../../types"

interface Props {
  productLine?: ProductLine
}

export function LeadProductLineBadge({ productLine }: Props) {
  if (!productLine || productLine === "mortgage") return null
  return <BadgeAlt>{PRODUCT_LINE_LABELS[productLine] ?? productLine}</BadgeAlt>
}
